// 2) Third-party library imports
import { get } from 'lodash-es';
import { all, call, fork, takeLatest } from 'redux-saga/effects';
import { post } from 'src/api';

// 3) Local imports
// 3.1 Constants
import { API_NAME } from '../../config/config';

// 3.4 Utility functions / types
import { DynamicObject } from '../../utils/commonInterfaces';

// 3.5 Redux actions
import { getBackupPerHourAction, recoverDataRequestAction } from './dataRecoverySlice';

/**
 * Function that submits the data recovery details to Rakspace API.
 * @param sagaPayload
 */
function* handleDataRecoveryRequest({ payload: sagaPayload }: any) {
    const { payload, callback } = sagaPayload;

    try {
        // To call async functions, use redux-saga's `call()`.
        const { body } = yield call(post, {
            apiName: API_NAME,
            path: '/company/restore/create',
            options: {
                body: payload
            }
        });
        const res: DynamicObject = yield body.json();

        res.IsSuccess = true;

        if (callback) callback(res);
    } catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.');
        }

        if (callback) {
            const returnData = get(err.response, 'data')
                ? err.response.data
                : { Messages: [err.message] };
            returnData.IsSuccess = false;

            callback(returnData);
        }
    }
}

/**
 * Function that gets the list of hours of back up datas API.
 * @param sagaPayload
 */
function* handleGetBackupPerHourRequest({ payload: sagaPayload }: any) {
    const { payload, callback } = sagaPayload;

    try {
        // To call async functions, use redux-saga's `call()`.
        const { body } = yield call(post, {
            apiName: API_NAME,
            path: '/company/describe/dbsnapshot',
            options: {
                body: payload
            }
        });
        const res: DynamicObject = yield body.json();
        
        if (callback) callback(res);
    } catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.');
        }
    }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchDataRecoveryRequest() {
    yield takeLatest(
        recoverDataRequestAction.type,
        handleDataRecoveryRequest
    );
}

function* watchGetBackupPerHourRequest() {
    yield takeLatest(
        getBackupPerHourAction.type,
        handleGetBackupPerHourRequest
    );
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* dataRecoverySaga() {
    yield all([
        fork(watchDataRecoveryRequest),
        fork(watchGetBackupPerHourRequest)
    ]);
}

export default dataRecoverySaga;
